<template>
  <div>
    <div class="taken">
      <div class="takentit">
        DO token is the<br />
        only token in the<br />
        DO network and <br />deeply integrated<br />
        into the DO <br />network economic<br />
        ecology
      </div>
      <div class="takentit1">
        DO token represents the rights and value that the<br />
        holders have in the DO network system
      </div>
    </div>
    <div class="taken1">
      <div class="tit">Basic information</div>
      <div class="tit1">
        The total circulation of DO tokens is 200<br />
        million. DO tokens were listed on exchanges in<br />
        August 2023 and have seen a peak increase<br />
        of about 2000%.
      </div>
      <div class="box box1">
        <img src="../../../assets/m/taken/1.png" />
        <div class="con">35% for circulation</div>
      </div>
      <div class="box box2">
        <img src="../../../assets/m/taken/2.png" />
        <div class="con">55% for node incentives</div>
      </div>
      <div class="box box3">
        <img src="../../../assets/m/taken/3.png" />
        <div class="con">5% for DO Labs</div>
      </div>
      <div class="box box4">
        <img src="../../../assets/m/taken/4.png" />
        <div class="con">5% for global ecological development</div>
      </div>
    </div>
    <div class="taken2">
      <div class="tit">Rights for holding DO</div>
      <div class="box">
        <img src="../../../assets/m/taken/5.png" />
        <div class="tit1">Staking</div>
        <div class="tit2">
          Each holder can stake their DO to gain a<br />
          stable and attractive APY for their <br />contribution to the DO
          network. A DO holder<br />
          only needs to stake at least 1,500 DO to <br />participate in, which
          means everyone can<br />
          enjoy the DO APY. For specific return rates,<br />
          users can refer to the table below.
        </div>
      </div>
      <div class="box">
        <img src="../../../assets/m/taken/6.png" />
        <div class="tit1">Governance</div>
        <div class="tit2">
          DO holders can participate in the governance <br />of DO network,
          submit proposals, vote for<br />
          proposals and be the decision makers of DO<br />
          network ecology.
        </div>
      </div>
      <div class="box">
        <img src="../../../assets/m/taken/7.png" />
        <div class="tit1">Be qualified</div>
        <div class="tit2">
          DO network, our partners and the <br />applications of DO network have
          been and<br />
          will keep running airdrop campaigns for the <br />community, and
          holding DO token may be a <br />key factor to get a huge airdrop.
        </div>
      </div>
    </div>
    <div class="taken3"></div>
    <div class="Intro1">
      <div class="title tit1">
        <!-- <div class="BigTitle">{{ $t("Learn.token1") }}</div> -->
        <div class="SubTitle">DO vesting schedule</div>
        <!-- <div class="detail">{{ $t("Learn.detail21") }}</div> -->
      </div>
      <div class="echartbox1" id="pChart">
        <div id="boxs" class="echartcontent"></div>
      </div>

      <div class="title tit2">
        <div class="SubTitle SubTitle1">Annual/Annualized return rate</div>
        <div class="echartbox" id="pChart1">
          <div id="boxss" class="echartcontent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import "swiper/swiper.less";
import { matrix } from "echarts";
let echarts = require("echarts");

export default {
  props: {
    blogList: {
      type: Array,
    },
  },
  components: {
    // Swiper,
    // SwiperSlide,
  },
  // directives: {
  //   swiper: directive,
  // },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  data() {
    return {
      swiperOptions: {
        // autoplay: {
        //   delay: 3000, //
        // },
        slidesPerView: 3,
        // loop: true,
        spaceBetween: 75,
      },
      timer: null,
    };
  },
  mounted() {
    //this.init();
    this.initechart();
    this.initechart1();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // init() {
    //     this.count = this.count++;
    //     this.timer = setInterval(() => {
    //         this.swiper.slideNext(500);
    //     }, 3000);
    // },
    // detalis(blog) {
    //     this.$router.push({
    //         path: "/pc/Blog/Details",
    //         query: { id: blog.blogId },
    //     });
    // },

    chartSize(container, charts) {
      function getStyle(el, name) {
        if (window.getComputedStyle) {
          return window.getComputedStyle(el, null);
        } else {
          return el.currentStyle;
        }
      }

      const hi = getStyle(container, "height").heigh;
      // if(w<=320){

      // }
      console.log(hi);
      charts.style.height = hi + 50 + "px";
      console.log(charts.style.height);
    },
    initechart() {
      const myChartId = document.getElementById("boxs");
      const pChart = document.getElementById("pChart");
      this.chartSize(pChart, myChartId);
      const w = window.screen.width;
      console.log(w);
      if (w <= 320) {
        pChart.style.height = 41 + "vh";
      } else if (w <= 360) {
        pChart.style.height = 46 + "vh";
      } else if (360 < w <= 375) {
        pChart.style.height = 46 + "vh";
      } else if (w >= 375) {
        pChart.style.height = 47 + "vh";
      } else if (768 <= w < 1024) {
        pChart.style.height = 52 + "vh";
      }
      // $("pinglun").style.height=$("hidden").offsetHeight + "px";
      const myChart = echarts.init(myChartId);

      // let myChart = echarts.init(document.getElementById("boxs"));

      // console.log(myChart);
      var option;
      option = {
        baseOption: {
          tooltip: {
            trigger: "axis",

            borderWidth: 0,
            confine: true,
            show: true,
            position: "left",
            backgroundColor: "rgba(255,255,255,0.8)",
            formatter: function (params) {
              let res = "";
              let year = "";
              let name = "";
              let value = "";
              let marker = "";
              let seriesY = "";
              let zongliang = [];

              params.forEach((item) => {
                if (item.axisValue == 1) {
                  year = "January";
                } else if (item.axisValue == 2) {
                  year = "February";
                } else if (item.axisValue == 3) {
                  year = "March";
                } else if (item.axisValue == 4) {
                  year = "April ";
                } else if (item.axisValue == 5) {
                  year = "May";
                } else if (item.axisValue == 6) {
                  year = "June";
                } else if (item.axisValue == 7) {
                  year = "July ";
                } else if (item.axisValue == 8) {
                  year = "August ";
                } else if (item.axisValue == 9) {
                  year = "September";
                } else if (item.axisValue == 10) {
                  year = "October ";
                } else if (item.axisValue == 11) {
                  year = "November ";
                } else if (item.axisValue == 12) {
                  year = "December";
                } else if (item.axisValue == 2022) {
                  year = "Before June";
                }
                name = "Month:" + year;
                marker = '<p style="text-align: left">' + item.marker;
                seriesY = item.seriesName;
                // if(seriesY.length < 10){
                //     seriesY +='&nbsp;'
                // }
                value = String(item.value).replace(/^(.*\..{10}).*$/, "$1");
                value = Number(value); // number = 12.3321
                zongliang.push(value);
                // zongliang +=value;
                // console.log(value);
                console.log(zongliang);

                value = "" + value + "M" + "</p>";

                // value = ''+ item.value + ' Million'+'</p>';
                res += marker + seriesY + ":" + value;
              });
              var d = 0;
              var sum = 0;
              for (var i = 0; i < zongliang.length; i++) {
                var str = "" + zongliang[i];
                if (str.indexOf(".") != -1) {
                  var temp = str.split(".")[1].length;
                  d = d < temp ? temp : d;
                }
              }
              var m = Math.pow(10, d);
              for (var i = 0; i < zongliang.length; i++) {
                sum += zongliang[i] * m;
              }

              return (res = name + "<br />" + res);
            },
          },

          legend: {
            //data: ['Seed round', 'Strategy round', 'Private round', 'IDO', 'Team'],
            //data:['Strategi cooperation','Airdrop', 'Team','Private round','Seed round', 'Strategy round',  'IDO'],
            data: [
              "technological development",
              "Community and operation",
              "Miner rewards",
              "Secondary circulation",
            ],
            icon: "rect", // 设置legend图标
            bottom: "bottom", //设置legend位置
            itemWidth: 20, // 设置宽度
            itemHeight: 4, // 设置高度
            itemGap: 6, //设置legend项之间的间距
            textStyle: {
              lineHeight: 16,
            },
            formatter: ["{a|{name}}"].join("\n"),
            textStyle: {
              rich: {
                a: {
                  width: 15,
                  fontSize: 12,
                  padding: 2,
                  lineHeight: 22,
                },
              },
            },
          },
          toolbox: {
            show: false, //工具消失
            feature: {
              saveAsImage: {},
            },
          },
          grid: {
            top: "6%",
            left: "2%",
            right: "2%",
            bottom: "26%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: false,
              //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              data: [
                "2025",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12",
              ],
              smooth: true, // 线条是否平滑
              symbol: "none", // 是否显示节点
            },
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              max: 150,

              axisLine: {
                show: true, //y轴线消失
              },

              axisTick: {
                show: true, //y轴坐标点消失
              },
              axisLabel: {
                formatter: "{value} M",
              },
            },
          ],
          series: [
            {
              name: "technological development",
              type: "line",
              stack: "Total",

              lineStyle: {
                normal: {
                  width: 0,
                },
              },

              showSymbol: false,
              smooth: true, // 线条是否平滑
              symbol: "none", // 是否显示节点
              areaStyle: {
                color: "#365EEC ",
              },
              itemStyle: {
                color: "#7594FF", //设置折线图颜色
                emphasis: {
                  color: "#7594FF",
                },
              },
              data: [
                0, 4.16665, 4.333316, 4.499982, 4.666648, 4.833314, 4.99998,
                5.166646, 5.333312, 5.499978, 5.666644, 5.83331, 5.999976,
              ],
              //  data:[0,0.166666,0.333332,0.499998,0.666664,0.833330,0.999996,1.166662,1.333328,1.499994,1.666660,1.833326,2.000000],
            },
            {
              name: "Community and operation",
              type: "line",
              type: "line",
              stack: "Total",
              areaStyle: {
                color: "#55699B",
              },
              lineStyle: {
                normal: {
                  width: 0,
                },
              },
              showSymbol: false,
              smooth: true, // 线条是否平滑
              symbol: "none", // 是否显示节点

              itemStyle: {
                color: "#AEDAFF", //设置折线图颜色
                emphasis: {
                  color: "#AEDAFF",
                },
              },
              // emphasis: {
              //     focus: 'series'
              // },
              areaStyle: {
                color: "#6EB9FE",
              },
              data: [
                0, 4.16665, 4.333316, 4.499982, 4.666648, 4.833314, 4.99998,
                5.166646, 5.333312, 5.499978, 5.666644, 5.83331, 5.999976,
              ],
              // data: [0,0.166666,0.333332,0.499998,0.666664,0.833330,0.999996,1.166662,1.333328,1.499994,1.666660,1.833326,2.000000],
            },
            {
              name: "Miner rewards",
              type: "line",
              stack: "Total",
              areaStyle: {
                color: "#43D2FF",
              },
              lineStyle: {
                normal: {
                  width: 0,
                },
              },
              itemStyle: {
                color: "#7FEEFF", //设置折线图颜色
                emphasis: {
                  color: "#7FEEFF",
                },
              },
              showSymbol: false,
              smooth: true, // 线条是否平滑
              symbol: "none", // 是否显示节点
              data: [
                0, 0.31046086175, 0.311469859550688, 0.312482136594227,
                0.313497703538159, 0.314516571074657, 0.31553874993065,
                0.316564250867925, 0.317593084683246, 0.318625262208466,
                0.319660794310644, 0.320699691892153, 0.321741965890803,
              ],
              //               data:[0,0.7329060754,0.7380974935,0.7433256840,0.7485909076,0.7538934266,0.7592335050,0.7646114090,0.7700274065,0.7754817673,0.7809747631,0.7865066677,0.7920777566

              // ]
              //               data: [0,0.7329060754,0.7380974935,0.7433256840,0.7485909076,0.7538934266,0.7592335050,0.7646114090,0.7700274065,0.7754817673,0.7809747631,0.7865066677,0.7920777566

              // ]
            },
            {
              name: "Secondary circulation",
              type: "line",
              stack: "Total",
              areaStyle: {
                color: "#55699B",
              },
              itemStyle: {
                color: "#8D9DC3", //设置折线图颜色
                emphasis: {
                  color: "#8D9DC3",
                },
              },

              smooth: true, // 线条是否平滑
              symbol: "none", // 是否显示节点
              // emphasis: {
              //     focus: 'series'
              // },
              data: [
                0, 112.745644199726, 113.390446059277, 114.036260195871,
                114.683089899409, 115.330938470484, 115.979809220415,
                116.629705471283, 117.280630555966, 117.932587818174,
                118.585580612485, 119.239612304377, 119.894686270268,
              ],
            },
          ],
        },
        media: [
          {
            option: {
              legend: {
                itemWidth: 10, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 6, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "26%",
                containLabel: true,
              },
            },
          },
          {
            query: {
              minAspectRatio: 1,
            },
            option: {
              legend: {
                itemWidth: 20, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 6, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "18%",
                containLabel: true,
              },
            },
          },
          {
            query: {
              maxAspectRatio: 1,
            },
            option: {
              legend: {
                itemWidth: 20, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 6, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "26%",
                containLabel: true,
              },
            },
          },
          {
            query: {
              maxWidth: 500,
            },
            option: {
              legend: {
                padding: [10, 2, 2, 2],
                itemWidth: 5, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 2, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "16%",
                containLabel: true,
              },
            },
          },
          {
            query: {
              maxWidth: 320,
            },
            option: {
              legend: {
                itemWidth: 8, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 6, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "28%",
                containLabel: true,
              },
            },
          },
        ],
      };

      myChart.dispatchAction({
        type: "hideTip",
        x: 20,
        y: 60,
      });
      myChart.clear();
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      // option && myChart.setOption(option);
      // window.onresize = function () {
      //   myChart.resize();
      // };
    },
    initechart1() {
      const myChartId = document.getElementById("boxss");

      const pChart = document.getElementById("pChart1");

      this.chartSize(pChart, myChartId);
      const w = window.screen.width;
      console.log(w);
      if (w <= 320) {
        pChart.style.height = 40 + "vh";
      } else if (w <= 360) {
        pChart.style.height = 42 + "vh";
      } else if (360 < w <= 375) {
        pChart.style.height = 43 + "vh";
      } else if (w > 375) {
        pChart.style.height = 47 + "vh";
      } else if (768 <= w < 1024) {
        pChart.style.height = 52 + "vh";
      }

      const myChart = echarts.init(myChartId);
      // let myChart = echarts.init(document.getElementById("boxss"));
      // console.log(myChart);
      var option;
      option = {
        baseOption: {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.8)", //
            formatter: function (params) {
              let res = "",
                sum = "year:" + params[0].axisValue + "<br/>";
              for (var i = 0; i < params.length; i++) {
                res +=
                  '<p style="text-align:left">' +
                  params[i].marker +
                  params[i].seriesName +
                  "   " +
                  params[i].data +
                  "%" + //12
                  "</p>";
              }

              return sum + res;
            },
          },
          legend: {
            icon: "rect", // 设置legend图标
            bottom: "bottom", //设置legend位置
            align: "left",
            padding: 10,
            itemWidth: 20, // 设置宽度
            itemHeight: 4, // 设置高度
            itemGap: 6, //设置legend项之间的间距
            data: [
              "0%-25%",
              "25%-30%",
              "30%-35%",
              "35%-40%",
              "40%-45%",
              "45%-50%",
              "50%-55%",
              "55%-60%",
              "60%-65%",
              "65%-70%",
              "70%-75%",
              "75%-80%",
              "80%-85%",
            ],

            formatter: ["{a|{name}}"].join("\n"),
            textStyle: {
              rich: {
                a: {
                  width: 45,
                  fontSize: 12,
                  align: "left",
                  lineHeight: 12,
                },
                b: {
                  fontSize: 15,
                  fontFamily: "DIN",
                  fontWeight: "bold",
                  color: "red",
                  align: "right",
                  padding: [0, 20, 0, 0],
                  lineHeight: 25,
                },
              },
            },
          },
          grid: {
            top: "6%",
            left: "2%",
            right: "2%",
            bottom: "32%",
            containLabel: true,
          },
          toolbox: {
            show: false, //工具消失
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
            ],
          },
          yAxis: {
            type: "value",
            min: 0,
            max: 12,

            interval: 1, // 刻度间隔
            axisLabel: {
              formatter: "{value} %-",
            },
          },
          series: [
            {
              name: "0%-25%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#5583FF ", //设置折线图颜色
              },
              data: [
                8.5, 7.65, 6.8, 5.95, 5.1, 4.25, 3.4, 2.55, 1.7, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   12, 11.4, 10.8, 10.2, 9.6, 9.0, 8.4, 7.8, 7.2, 6.6, 6.0, 5.4,
              //   4.8, 4.2, 3.6, 3.0, 2.4, 1.8, 1.8,
              // ],
            },
            {
              name: "25%-30%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#94B1FC", //设置折线图颜色
              },
              data: [
                7.86, 7.01, 6.16, 5.31, 4.46, 3.61, 2.76, 1.91, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   11.51, 10.91, 10.31, 9.71, 9.11, 8.51, 7.91, 7.31, 6.71, 6.11,
              //   5.51, 4.91, 4.31, 3.71, 3.11, 2.51, 1.91, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "30%-35%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#CBD5EF", //设置折线图颜色
              },
              data: [
                7.23, 6.38, 5.53, 4.68, 3.83, 2.98, 2.13, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   11.01, 10.41, 9.81, 9.21, 8.61, 8.01, 7.41, 6.81, 6.21, 5.61,
              //   5.01, 4.41, 3.81, 3.21, 2.61, 2.01, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "35%-40%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#CBD5EF", //设置折线图颜色
              },
              data: [
                6.59, 5.74, 4.89, 4.04, 3.19, 2.34, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   10.52, 9.92, 9.32, 8.72, 8.12, 7.52, 6.92, 6.32, 5.72, 5.12,
              //   4.52, 3.92, 3.32, 2.72, 2.12, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "40%-45%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#43D2FF", //设置折线图颜色
              },
              data: [
                5.95, 5.1, 4.25, 3.4, 2.55, 1.7, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   10.02, 9.42, 8.82, 8.22, 7.62, 7.02, 6.42, 5.82, 5.22, 4.62,
              //   4.02, 3.42, 2.82, 2.22, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "45%-50%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#6EB9FE", //设置折线图颜色
              },
              data: [
                5.31, 4.46, 3.61, 2.76, 1.91, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   9.52, 8.92, 8.32, 7.72, 7.12, 6.52, 5.92, 5.32, 4.72, 4.12,
              //   3.52, 2.92, 2.32, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ], //
            },
            {
              name: "50%-55%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#365EEC", //设置折线图颜色
              },
              data: [
                4.68, 3.83, 2.98, 2.13, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   9.03, 8.43, 7.83, 7.23, 6.63, 6.03, 5.43, 4.83, 4.23, 3.63,
              //   3.03, 2.43, 1.83, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "55%-60%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#6EB9FE", //设置折线图颜色
              },
              data: [
                4.04, 3.19, 2.34, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   8.53, 7.93, 7.33, 6.73, 6.13, 5.53, 4.93, 4.33, 3.73, 3.13,
              //   2.53, 1.93, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "60%-65%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#43D2FF", //设置折线图颜色
              },
              data: [
                3.4, 2.55, 1.7, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   8.04, 7.44, 6.84, 6.24, 5.64, 5.04, 4.44, 3.84, 3.24, 2.64,
              //   2.04, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "65%-70%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#3F1698", //设置折线图颜色
              },
              data: [
                2.76, 1.91, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   7.54, 6.94, 6.34, 5.74, 5.14, 4.54, 3.94, 3.34, 2.74, 2.14, 1.8,
              //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "70%-75%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#CBD5EF", //设置折线图颜色
              },
              data: [
                2.13, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   7.05, 6.45, 5.85, 5.25, 4.65, 4.05, 3.45, 2.85, 2.25, 1.8, 1.8,
              //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "75%-80%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#94B1FC", //设置折线图颜色
              },
              data: [
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   6.55, 5.95, 5.35, 4.75, 4.15, 3.55, 2.95, 2.35, 1.8, 1.8, 1.8,
              //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
            {
              name: "80%-85%",
              type: "line",
              lineStyle: {
                width: 1,
              },
              smooth: 0.1, // 线条是否平滑
              symbol: "none", // 是否显示节点
              itemStyle: {
                color: "#5583FF", //设置折线图颜色
              },
              data: [
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
                1.5, 1.5, 1.5, 1.5, 1.5, 1.5, 1.5,
              ],
              // data: [
              //   6.06, 5.46, 4.86, 4.26, 3.66, 3.06, 2.46, 1.86, 1.8, 1.8, 1.8,
              //   1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8, 1.8,
              // ],
            },
          ],
        },
        media: [
          {
            option: {
              legend: {
                padding: [2, 2, 2, 2],
                itemWidth: 10, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 10, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "26%",
                containLabel: true,
              },
            },
          },
          {
            query: {
              minAspectRatio: 1,
            },
            option: {
              legend: {
                itemWidth: 20, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 6, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "26%",
                containLabel: true,
              },
            },
          },
          {
            query: {
              maxAspectRatio: 1,
            },
            option: {
              legend: {
                itemWidth: 20, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 6, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "26%",
                containLabel: true,
              },
            },
          },
          {
            query: {
              maxWidth: 500,
            },
            option: {
              legend: {
                padding: [10, 2, 2, 2],
                itemWidth: 10, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 6, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "22%",
                containLabel: true,
              },
            },
          },
          {
            query: {
              maxWidth: 320,
            },
            option: {
              legend: {
                itemWidth: 8, // 设置宽度
                itemHeight: 4, // 设置高度
                itemGap: 2, //设置legend项之间的间距
              },
              grid: {
                top: "6%",
                left: "2%",
                right: "2%",
                bottom: "26%",
                containLabel: true,
              },
            },
          },
        ],
      };
      myChart.clear();
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      // window.onresize = function () {
      //   myChart.resize();
      // };
      // option && myChart.setOption(option);
    },
  },
  created() {},
};
</script>
<style lang="less">
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
.scale {
}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}

li {
  list-style: none;
}

.Intro,
.Intro1 {
  text-align: center;

  width: 100%;
  // padding-top: 120px;
  color: #000000;
  .tit1 {
    padding-top: 231px;
    // padding-top: 0 !important;
  }
  .tit2 {
    margin-bottom: 100px;
  }
  .echartbox1 {
    width: 720px;
    height: 48vh;
    background: #ffffff;
    box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.03);
    border-radius: 15px 15px 15px 15px;
    opacity: 1;
    border: 1px solid #efefef;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 200px;
    .echartcontent {
      width: 95%;
      height: 54vh;
      margin: 0 0.1rem;
    }
  }
  .title {
    text-align: center;

    // height: 761px;
    // background: url("../../../assets/m/intro/bgi.png") no-repeat center/100%
    // 100%;
    #pChart1 {
      margin-bottom: 23vh;
    }
    .echartbox {
      width: 720px;

      margin-bottom: 55vh;
      background: #ffffff;
      box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.03);
      border-radius: 15px 15px 15px 15px;
      opacity: 1;
      border: 1px solid #efefef;
      margin: 0 auto;
      margin-top: 50px;
      margin-bottom: 100px;
      .echartcontent {
        width: 95%;
        height: 54vh;
        margin: 0 0.1rem;
      }
    }
    .BigTitle {
      padding-top: 120px;
      width: 648px;
      font-size: 64px;
      font-family: Poppins-Black, Poppins;
      font-weight: 900;
      color: #000000;
      line-height: 83px;
      margin: 0 auto;
    }
    .SubTitle {
      height: 55px;
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 32px;
      color: #1a1a2c;
      line-height: 54px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      padding-top: 20px;
      padding-bottom: 40px;
    }
    .SubTitle1 {
      margin-top: 100px;
    }
    .detail {
      width: 645px;
      font-size: 26px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #61666b;
      line-height: 43px;
      margin: 0 auto;
    }
  }
  .box-card {
    margin-top: 140px;
    .item {
      cursor: pointer;
      padding: 0;
      margin: 0;
      img {
        width: 650px;
        height: 427px;
        background: #4573e7;
        border-radius: 25px 25px 25px 25px;
        box-shadow: 0px 25px 82px 1px rgba(0, 0, 0, 0.04);
        opacity: 1;
      }
      .level {
        margin-top: 30px;
        margin-bottom: 120px;
        font-size: 36px;
        font-family: Poppins-SemiBold, Poppins;
        font-weight: 600;
        color: #1a1a2c;
        line-height: 61px;
      }
    }
  }
}
.taken {
  width: 648px;
  // height: 578px;
  margin: 0 auto;
  margin-top: 120px;
  .takentit {
    font-family: Poppins, Poppins;
    font-weight: 900;
    font-size: 64px;
    color: #000000;
    line-height: 83px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .takentit1 {
    margin: 0 auto;
    margin-top: 20px;
    width: 645px;
    height: 86px;
    font-family: Poppins, Poppins;
    font-weight: 500;
    font-size: 26px;
    color: #61666b;
    line-height: 43px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}
.taken1 {
  width: 650px;
  margin: 0 auto;
  margin-top: 106px;
  .tit {
    font-family: Poppins, Poppins;
    font-weight: 600;
    font-size: 32px;
    color: #1a1a2c;
    line-height: 54px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .tit1 {
    font-family: Poppins, Poppins;
    font-weight: 500;
    font-size: 28px;
    color: #61666b;
    line-height: 43px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 34px;
    margin-bottom: 5px;
  }
  .box {
    display: flex;
    height: 61px;
    border-radius: 33px 33px 33px 33px;
    line-height: 61px;
    text-align: center;
    margin-top: 32px;
    img {
      width: 40px;
      height: 40px;
      margin-top: 11px;
      margin-left: 13px;
    }
    .con {
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 27px;
      color: #ffffff;
      line-height: 40px;
      text-align: left;
      font-style: normal;
      height: 60px;
      line-height: 60px;
      margin-left: 13px;
      text-transform: none;
    }
  }
  .box1 {
    width: 333px;
    background: #4573e7;
    margin-left: 158px;
  }
  .box2 {
    width: 407px;
    background: #47bbdb;
    margin-left: 121px;
  }
  .box3 {
    width: 280px;
    background: #aa4cd9;
    margin-left: 185px;
  }
  .box4 {
    width: 596px;
    background: #e58a51;
    margin-left: 19px;
  }
}
.taken2 {
  width: 650px;
  margin: 0 auto;
  margin-top: 107px;
  .tit {
    font-family: Poppins, Poppins;
    font-weight: 600;
    font-size: 32px;
    color: #1a1a2c;
    line-height: 54px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .box {
    margin-top: 70px;
    img {
      width: 133px;
      height: 133px;
      margin-left: 258px;
    }
    .tit1 {
      height: 55px;
      font-family: Poppins, Poppins;
      font-weight: 600;
      font-size: 32px;
      color: #000000;
      line-height: 54px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
    .tit2 {
      font-family: Poppins, Poppins;
      font-weight: 500;
      font-size: 28px;
      color: #61666b;
      line-height: 46px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 30px;
    }
  }
}
.taken3 {
  background: url("../../../assets/m/taken/8.png") no-repeat;
  background-size: cover;
  height: 374px;
  margin-top: 120px;
}
</style>
